// extracted by mini-css-extract-plugin
export default {"image-search":"index_image-search__rnmR1","fiexd-top":"index_fiexd-top__hTP1F"};